import React, { Suspense } from 'react'

import { AuthRefresher, AuthRefresherProps } from './components-hydrated/auth-refresher/auth-refresher.js'
import { Container } from './components/container/container.js'
import { Footer, FooterProps } from './components/footer/footer.js'
import { HeaderFlex, HeaderFlexProps } from './components/header-flex/header-flex.js'
import { Header, HeaderProps } from './components/header/header.js'
import { Hero, HeroProps } from './components/hero/hero.js'
import { Main } from './components/main/main.js'
import { NotificationList, NotificationListProps } from './components/notification-list/notification-list.js'
import { FlowPicker, FlowPickerProps } from './views/flow-picker/flow-picker-step.js'
import { Loading, LoadingProps } from './views/loading/loading.js'
import { NotificationPage, NotificationPageProps } from './views/notification/notification.js'
import { Portal, PortalProps } from './views/portal/portal.js'
import { ViewPrivacyPolicy, ViewPrivacyPolicyProps } from './views/portal/privacy-policy/privacy-policy.js'
import { SignRejectProps } from './views/sign-reject/sign-reject.js'
import { SignSuccessProps } from './views/sign-success/sign-success.js'
import { Subscription, SubscriptionProps } from './views/subscription/subscription.js'

export interface RootProps {
    header?: HeaderProps
    footer?: FooterProps
    loading?: LoadingProps
    portal?: PortalProps
    portalHeader?: HeaderFlexProps
    flowPickerProps?: FlowPickerProps
    creditFailedProps?: NotificationPageProps
    authErrorProps?: NotificationPageProps
    privacyPolicyProps?: ViewPrivacyPolicyProps
    subscriptionsExist?: NotificationPageProps
    subscription?: SubscriptionProps
    signSuccess?: SignSuccessProps
    signReject?: SignRejectProps
    notifications?: NotificationListProps
    banner?: HeroProps
    portalFooter?: FooterProps
    authRefresher?: AuthRefresherProps
}

export const Root = (props: RootProps): JSX.Element => {
    if (props.portal) {
        return (
            <Suspense>
                {props.portalHeader && <HeaderFlex {...props.portalHeader} />}
                <Main hasPadding={true}>
                    <Container>
                        {props.loading && <Loading {...props.loading} />}
                        {!props.loading && props.portal && <Portal {...props.portal} />}
                    </Container>
                </Main>
                {props.notifications?.items && <NotificationList {...props.notifications} />}
                {props.portalFooter && <Footer {...props.portalFooter} />}
                {props.authRefresher && <AuthRefresher {...props.authRefresher} />}
            </Suspense>
        )
    }

    return (
        <Suspense>
            {props.header && <Header {...props.header} />}
            <Main>
                {props.banner && <Hero {...props.banner} />}
                <Container>
                    {props.loading && <Loading {...props.loading} />}
                    {props.flowPickerProps && <FlowPicker {...props.flowPickerProps} />}
                    {props.subscription && <Subscription {...props.subscription} />}
                    {props.creditFailedProps && <NotificationPage {...props.creditFailedProps} />}
                    {props.authErrorProps && <NotificationPage {...props.authErrorProps} />}
                    {props.privacyPolicyProps && <ViewPrivacyPolicy {...props.privacyPolicyProps} />}
                    {props.subscriptionsExist && <NotificationPage {...props.subscriptionsExist} />}
                </Container>
            </Main>
            {props.notifications?.items && <NotificationList {...props.notifications} />}
            {props.footer && <Footer {...props.footer} />}
        </Suspense>
    )
}
